import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { cx } from "shared/utils";

interface EditorUserMention {
  id: string;
}

export const EditorUserMention = (props: EditorUserMention) => {
  const { id } = props;

  const { data: userDetails, isLoading } = useQuery({
    queryKey: ["USER_DETAILS", id],
    queryFn: () =>
      instance.get(`/portal/v1/users/${id}`).then((res) => res.data),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(id)
  });

  if (isLoading) return null;

  if (!userDetails)
    return (
      <div className="not-prose inline px-1 py-0.5 rounded bg-custom-background-80 text-custom-text-300 no-underline">
        @deactivated user
      </div>
    );

  return (
    <div
      className={cx(
        "not-prose group/user-mention inline rounded bg-custom-primary-100/20 text-custom-primary-100 no-underline",
        "font-bold text-primary-500"
      )}
    >
      @{userDetails?.name}
    </div>
  );
};
